export interface IMicrophoneAccessModalLogic {
}

export const useMicrophoneAccessModalLogic = (): IMicrophoneAccessModalLogic => {
  return {};
}
